module.exports = new __parcel__URL__("drainlife.b828bca7.png").toString();